import { colors } from '../foundation';

type Props = {
  color?: (typeof colors.red)[100] | typeof colors.primary.white;
};

const TwitterIcon = ({ color = colors.primary.white }: Props) => (
  <svg width="24" height="24" viewBox="0 -2 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 2.4312C23.1 2.8062 22.1625 3.1062 21.1875 3.2187C22.2 2.6187 22.9875 1.6437 23.3625 0.481201C22.425 1.0437 21.375 1.4562 20.25 1.6812C19.3125 0.706201 18.0375 0.106201 16.6125 0.106201C13.875 0.106201 11.7 2.3187 11.7 5.0187C11.7 5.3937 11.7375 5.7687 11.8125 6.1437C7.725 5.9562 4.0875 3.9687 1.6875 1.0062C1.275 1.7187 1.0125 2.5812 1.0125 3.4812C1.0125 5.2062 1.875 6.7062 3.1875 7.5687C2.3625 7.5312 1.6125 7.3062 0.975 6.9687C0.975 7.0062 0.975 7.0062 0.975 7.0437C0.975 9.4437 2.6625 11.4312 4.9125 11.8812C4.5 11.9937 4.05 12.0687 3.6 12.0687C3.3 12.0687 2.9625 12.0312 2.6625 11.9937C3.3 13.9437 5.1 15.3687 7.275 15.4062C5.5875 16.7187 3.45 17.5062 1.1625 17.5062C0.75 17.5062 0.375 17.4687 0 17.4312C2.175 18.7812 4.7625 19.6062 7.5375 19.6062C16.6125 19.6062 21.5625 12.1062 21.5625 5.5812C21.5625 5.3562 21.5625 5.1687 21.5625 4.9437C22.5 4.2687 23.325 3.4062 24 2.4312Z"
      fill={color}
    />
  </svg>
);

export default TwitterIcon;
